import { Expose } from 'class-transformer';
import { ElementOptions } from './element-options';

export enum SingleSelectActions {
  GO_TO_GOOGLE_MAPS = 'go_to_google_maps',
}
export class SurveySingleSelectOptions extends ElementOptions {
  @Expose()
  value!: number;

  @Expose()
  allowCustomValue!: boolean;

  @Expose()
  outlined!: boolean;

  @Expose()
  underlined!: boolean;

  @Expose()
  icon!: boolean;

  @Expose()
  action!: SingleSelectActions | null;
}
